import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { eliminarCita } from "../services/citas.service";

import { successNotification, dangerNotification } from '../../../redux/slices/ui';

export const useCitaEliminar = (id) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const eliminarCitaMutation = useMutation({
        mutationFn: eliminarCita,
        onSuccess: (cita, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ['citas', id] });
            queryClient.invalidateQueries({ queryKey: ['agenda'], exact: false });
            queryClient.invalidateQueries({ queryKey: ['agendaInmunoterapia'], exact: false });
            dispatch(successNotification('Cita eliminada'));
        },
        onError: (error, variables, context) => {
            variables.onComplete();
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        eliminarCitaMutation,
    }
}